import { h } from './pragma.mjs';

export default (aktivni) => {
    return (
      <gov-tabs-item label="Můj katastr" id="katastr" default={aktivni}>
        <gov-message variant="primary">
          Pro zobrazení obsahu stránky Můj katastr je třeba přihlášení do
          portálu.
          <br />
          <br />
          <gov-button
            id="loginButtonMujKatastr"
            href="#"
            variant="secondary"
            type="solid"
            size="m"
            wcag-label="Přihlášení uživatele"
          >
            Přihlásit do portálu
          </gov-button>
        </gov-message>

      </gov-tabs-item>
    );
}